import { Auth } from "aws-amplify";
import type {
  CognitoUser,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import type { FederatedSignInOptions } from "@aws-amplify/auth/lib-esm/types/Auth";
import type { ICredentials } from "@aws-amplify/core";
import { gql } from "@apollo/client";

export const NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED";

export const signIn = (
  username: string,
  password: string
): Promise<CognitoUser> => {
  return Auth.signIn(username, password);
};

export const getAuthenticatedUser = (): Promise<CognitoUser> => {
  return Auth.currentAuthenticatedUser();
};

export const getCurrentSession = (): Promise<CognitoUserSession> => {
  return Auth.currentSession();
};

// mfaType mirrors the challenge types accepted by Auth.confirmSignIn.
export const confirmSignIn = (
  user: CognitoUser,
  code: string,
  mfaType?: "SMS_MFA" | "SOFTWARE_TOKEN_MFA" | null
): Promise<CognitoUser> => {
  return Auth.confirmSignIn(user, code, mfaType);
};

export const completeNewPassword = (
  user: CognitoUser,
  newPassword: string
): Promise<CognitoUser> => {
  return Auth.completeNewPassword(user, newPassword);
};

export const federatedSignIn = (
  options: FederatedSignInOptions
): Promise<ICredentials> => {
  return Auth.federatedSignIn(options);
};

export const UPDATE_LAST_LOGIN = gql`
  mutation {
    login {
      ok
      msg
    }
  }
`;

export const GET_ORGANIZATIONS = gql`
  query {
    organizations {
      slug
      name
      domains
      identity_provider
      password_enabled
      accounts {
        id
        name
      }
    }
  }
`;
